import { SET_SELECTED_TIME_SLOT } from 'actions';
import { ITimeSlot } from 'typings';

export function setSelectedTimeSlot(selectedTimeSlot?: ITimeSlot) {
  return { selectedTimeSlot, type: SET_SELECTED_TIME_SLOT };
}
